import { Model } from '@vuex-orm/core'
// Import profond, comme le fait deja App.vue pour les feuilles de style de la
// toolbox : `requestSerializer` n'est pas reexporte par son wrapper, mais le
// paquet expedie bien `src/store/*`. C'est ce serialiseur qui transforme
// { document, attachments } en multipart JSON:API, forme qu'attend la route
// POST /food-pairings de l'intranet.
import requestSerializer from 'aveine-toolbox/src/store/adapter/serializer'

/**
 * Referentiel des accords mets-vins (REDMINE-12958).
 *
 * Ce modele vit ici et non dans aveine-toolbox : le back-office est le seul
 * client qui edite ce referentiel, l'application mobile ne fait que le lire a
 * travers consumer-api.
 */
export default class FoodPairing extends Model {
  static entity = 'food_pairings'

  static fields () {
    return {
      '$entity_name': this.attr(this.entity),
      'id': this.attr(null),
      // Traduction : un objet { fr, en, it, de, ko, zh, ja, es }, pas une
      // chaine. Meme forme que `description` sur les domaines.
      'name': this.attr({}),
      // Categorie : viande, poisson, fromage, dessert...
      'category': this.attr(null),
      // URI signee construite par creddy. En ecriture, le formulaire y place le
      // File a televerser et le deplace vers `attachments` avant l'envoi.
      'image': this.attr(null),
      // Apercu local en base64, jamais envoye au serveur : il sert seulement a
      // savoir qu'une NOUVELLE image a ete choisie.
      'displayed_image': this.attr(null),
      'created_at': this.string(),
      'updated_at': this.string(),
      'deleted': this.boolean(false)
    }
  }

  static readOnlyFields = ['displayed_image']

  static apiConfig = {
    transformRequest: (data) => {
      if (data) {
        return requestSerializer(this.entity, data)
      } else {
        return null
      }
    }
  }
}
